import { render, staticRenderFns } from "./errorQuestion.vue?vue&type=template&id=67e010b2&scoped=true&"
import script from "./errorQuestion.vue?vue&type=script&lang=js&"
export * from "./errorQuestion.vue?vue&type=script&lang=js&"
import style0 from "./errorQuestion.vue?vue&type=style&index=0&id=67e010b2&prod&lang=scss&"
import style1 from "./errorQuestion.vue?vue&type=style&index=1&id=67e010b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e010b2",
  null
  
)

export default component.exports